export interface PeppolSendOptions {
	po: string;
	deliveryNumber: string;
	files: File[];
	sendCopyToBookkeeper: boolean;
	endpointID: string;
}

export class SaleEditStateSaveModalData {
	preventClose:boolean = false;
	loading: boolean = false;
	quickBankEdit:boolean = false;
	depositAmount:number = 0.0;
	sendViaPeppol:boolean = false;
	pendingPeppolSend:boolean = false;
	peppolOptions: PeppolSendOptions = {
		po: "",
		deliveryNumber: "",
		files: [],
		sendCopyToBookkeeper: false,
		endpointID: ""
	};
}